<template>
<loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
      <HeadlineSubScroll 
          :title="$t('settings.general')" 
          target="/Settings" 
          :hassubline="!isShrunk"
          :hasmenu="false"
          :isShrunk="isShrunk"
          >
            <template #icon>
              <IconEditSquare             
                class="transition-all duration-300"
                :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
            </template>
            <template #subline>
              {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
            </template>
      </HeadlineSubScroll>

    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody>
        <template v-slot:formgrid>
          <div class="form-group">
            <InputLabelError
              v-model="client_info.name"
              :label="$t('setgeneral.wallboxname')"
              :placeholder="$t('setgeneral.wallboxname')"
              @update:modelValue ="onChange"
            />
            <InputLabelError 
              v-model="client_info.info"
              :label="$t('setgeneral.wallboxinfo')"
              :placeholder="$t('setgeneral.wallboxinfo')"
              @update:modelValue ="onChange"
            />                
          </div>         
          <div class="form-group">
            <TextfieldWithLabel
              :label="$t('setgeneral.installedsw')"
              :text="$t('setgeneral.version')+': '+swversions.linuxVersion"
              @update:modelValue ="onChange"
            />
            <div class="form-group text-right">
              <a 
                href="wallbox/download/THIRD_PARTY_LICENSES.txt" 
                target="_blank" 
                rel="noopener"
                class="text-gray-400 text-sm font-sans"
              >
                {{$t('common.third_party')}}
              </a>
            </div>
          </div>

          <div v-if="this.$store.state.Role=='operator'" class="form-group">
              <InputLabelError 
                v-model="dayprice"
                :label="$t('setgeneral.statprice')"
                :placeholder="$t('setgeneral.statpriceph')"
                validationType="decimal"
                :validator_off="dayprice==''"
                @update:modelValue ="onChange"
              />
            </div>

            <div class="form-group">
          </div>


          <div class="form-group mt-4 mb-2">
            <ToggleWithLabel 
              v-model="freecharge"
              :label="$t('setgeneral.freecharging')"
              :ontext="$t('common.on')"
              :offtext="$t('common.off')"
              @update:modelValue ="onChange"
            />
          </div>   
          <div class="form-group mt-4 mb-2">
            <ToggleWithLabel 
              v-model="deauth"
              :label="$t('setgeneral.stopcharging')"
              :ontext="$t('common.yes')"
              :offtext="$t('common.no')"
              @update:modelValue ="onChange"
            />
          </div>
          <div v-if="outlet" class="form-group mt-4 mb-2">
            <ToggleWithLabel 
              v-model="lockcable"
              :label="$t('setgeneral.lockcable')"
              :ontext="$t('common.yes')"
              :offtext="$t('common.no')"
              @update:modelValue ="onChange"
            />
          </div>
          <div v-if="outlet&&!lockcable" class="form-group mt-4 mb-2">
            <ToggleWithLabel 
              v-model="locktype"
              :label="$t('setgeneral.releasecable')"
              :ontext="$t('common.on')"
              :offtext="$t('common.off')"
              @update:modelValue ="onChange"
            />
          </div>
          <!--
          <div v-else class="form-group">
          </div>
          -->
          <div v-if="outlet&&lockcable" class="form-group mb-2 sm:col-span-2">
            <TextfieldWithLabel
              :smalltxt="true"
              :text="$t('setgeneral.lockcablehelp')"
            />
          </div>

          <div v-if="midError" class="form-group mt-4 mb-2 sm:col-span-2">
            <ToggleWithLabel 
              v-model="ignoreMidError"
              :label="$t('setgeneral.miderror')"
              labelcolor="red"
              :ontext="$t('common.yes')"
              :offtext="$t('common.no')"
              @update:modelValue ="onChange"
            />
          </div>

          <div v-if="this.$store.state.Role=='operator'||this.$store.state.Role=='admin'" class="w-full form-group mb-4">
            <label v-if="this.currentSettings.noOfPhasesInstall==1&&this.$store.state.Role=='operator'" class="font-medium text-sm text-skin-b-list-mute" for="">
              {{ $t('setgeneral.limitmax1phase') }}</label>
            <label v-if="this.currentSettings.noOfPhasesInstall==3&&this.$store.state.Role=='operator'" class="font-medium text-sm text-skin-b-list-mute" for="">
              {{ $t('setgeneral.limitmax3phase') }}</label>
            <label v-if="this.currentSettings.noOfPhasesInstall==1&&this.$store.state.Role=='admin'" class="font-medium text-sm text-skin-b-list-mute" for="">
              {{ $t('setgeneral.setmax1phase') }}</label>
            <label v-if="this.currentSettings.noOfPhasesInstall==3&&this.$store.state.Role=='admin'" class="font-medium text-sm text-skin-b-list-mute" for="">
              {{ $t('setgeneral.setmax3phase') }}</label>

              <SelectWithLabelIcon
                v-model="chargeselect"
                @update:model-value="selectchargepower(chargeselect)"       
                @update:modelValue ="onChange"
              >
              <template v-slot:options>
                <option v-for="(power, index) in chargepowerlist" :key="index" :value="index">
                  {{ $t('setgeneral.powerampere', {power:power,ampere:index+this.currentSettings.minCurrent} ) }}
                </option>
              </template>
              </SelectWithLabelIcon>
          </div>

          <div v-if="(this.$store.state.Role=='operator'||this.$store.state.Role=='admin')&&chargepower>0" class="form-group mb-4"> 
            <label class="font-medium text-sm text-skin-b-list-mute" for="">{{ $t('setgeneral.loadtime') }}</label>
            <div class="relative mt-1 overflow-x-auto bg-skin-b-list-back rounded-lg border-2 border-skin-b-list-bord">
              <table class="w-full text-left font-medium text-lg text-skin-b-list-base">
                  <tbody>
                      <tr class="border-b">
                          <th scope="row" class="px-6 py-2 whitespace-nowrap">
                            {{ $t('setgeneral.power', {power:35} ) }}
                          </th>
                          <td class="px-6 py-2">
                              {{ formatchargetime(35000/(this.chargepower*this.currentSettings.noOfPhasesInstall*230)) }}
                          </td>
                      </tr>
                      <tr class="border-b">
                          <th scope="row" class="px-6 py-2 whitespace-nowrap">
                            {{ $t('setgeneral.power', {power:50} ) }}
                          </th>
                          <td class="px-6 py-2">
                            {{ formatchargetime(50000/(this.chargepower*this.currentSettings.noOfPhasesInstall*230)) }}
                          </td>
                      </tr>
                      <tr class="">
                          <th scope="row" class="px-6 py-2 whitespace-nowrap">
                            {{ $t('setgeneral.power', {power:75} ) }}
                          </th>
                          <td class="px-6 py-2">
                            {{  formatchargetime(75000/(this.chargepower*this.currentSettings.noOfPhasesInstall*230)) }}
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>        
          </div>

        </template>
        <template v-slot:formbottom>

        <div class="w-full mt-6">
          <ActionButton :disabled="!isDirty" @click="saveGeneral()">
            {{ $t('common.save') }}
          </ActionButton>
        </div>
        <div v-if="!restartmodal&&!countermodal" class="w-full mt-6 text-right">
          <ActionButton @click="restartmodal=true" color="red" :wfull="false">
            {{ $t('common.restartwallbox') }}
          </ActionButton>
        </div>
        <div v-if="this.$store.state.Role=='admin'" class="w-full mt-6 text-right">
            <ActionButton @click="resetmodal=true" color="red" :wfull="false">
              {{ $t('common.factoryreset') }}
            </ActionButton>
        </div>


        <ConfirmLeaveModal
          v-model:show="showLeaveDialog"
          :pendingNavigation="this.leaveDialog"
        />

          <div v-if="restartmodal" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <button @click.prevent="submitForm" @click="restartmodal=false" type="button" class="absolute top-3 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                          <span class="sr-only">Close modal</span>
                      </button>
                      <div class="p-6 text-center">
                          <svg aria-hidden="true" class="mx-auto mb-4 w-14 h-14" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                          <h3 class="mb-5 text-lg font-semibold text-gray-500">
                            {{ $t('common.restartquestion') }}</h3>

                            <ActionButton @click="restartmodal=false;restartBox();countermodal=true;restarttimer();" color="red" :wfull="false" :margin="true">
                              {{ $t('common.restartconfirm') }}
                            </ActionButton>
                            <ActionButton @click="restartmodal=false" :wfull="false">
                              {{ $t('common.cancel') }}
                            </ActionButton>
                      </div>
                  </div>
              </div>
          </div>
          <div v-if="resetmodal" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <button @click.prevent="submitForm" @click="resetmodal=false" type="button" class="absolute top-3 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                          <span class="sr-only">Close modal</span>
                      </button>
                      <div class="p-6 text-center">
                          <svg aria-hidden="true" class="mx-auto mb-4 w-14 h-14" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                          <h3 class="mb-5 text-lg font-semibold text-gray-500">
                            {{ $t('common.resetquestion') }}</h3>

                            <ActionButton @click="resetmodal=false;resetBox();countresetmodal=true;" color="red" :wfull="false" :margin="true">
                              {{ $t('common.resetconfirm') }}
                            </ActionButton>
                            <ActionButton @click="resetmodal=false" :wfull="false">
                              {{ $t('common.cancel') }}
                            </ActionButton>
                      </div>
                  </div>
              </div>
          </div>

          <div v-if="countermodal" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <div class="p-6 text-center">
                        <h1 class="mb-5 text-5xl font-semibold">
                            {{counter}} s</h1>
                        <h3 class="mb-5 text-lg font-semibold">
                          {{ $t('common.restartnotice') }}</h3>
                      </div>
                  </div>
              </div>
          </div>
          <div v-if="countresetmodal" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <div class="p-6 text-center">
                        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                        <h3 class="mb-5 text-lg font-semibold">
                          {{ $t('common.resetnotice') }}</h3>
                      </div>
                  </div>
              </div>
          </div>
        </template>
    </SettingsBody>
  </SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconEditSquare from './icons/IconEditSquare.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import InputLabelError from './elements/InputLabelError.vue'
import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'
import { useI18n } from 'vue-i18n'

export default {
  setup () {
    const { t,d,n } = useI18n()
    return { t,d,n }
  }, 
  components: {
    SrcBackgroundScroll, HeadlineSubScroll, IconEditSquare,
    SettingsHeader, SettingsBody, ActionButton, InputLabelError, TextfieldWithLabel, ToggleWithLabel, SelectWithLabelIcon, ConfirmLeaveModal
  },
  data() {
    return {
          isLoading: false,
          wbselectshow: false,
          restartmodal: false,
          resetmodal: false,
          countresetmodal: false,
          countermodal: false,
          counter: 120,
          interval: '',
          saveto: this.$store.state.WbId,
          renameWb: '',
          renameInfo: '',
          dayprice: '',
          nightprice: '',
          lvdayprice: '',
          lvnightprice: '',
          freecharge: false,
          deauth: false,
          outlet: false,
          midError: false,
          ignoreMidError: false,
          lockcable: false,
          locktype: false,
          clients_list: [],
          client_info: [],
          swversions: [],
          currrentPricelist: [],
          currentSettings: [],
          chargepowerlist: [],
          chargepower: 0,
          chargeselect: 0,
          isShrunk: false,

          isDirty:false,
          showLeaveDialog:false

    }
  },
  computed: {
  },

  beforeRouteLeave(to, from, next) {

    if (this.isDirty) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },
  methods: {

    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},

    restarttimer() {
        this.interval = setInterval(() => {
          if (this.counter === 0) {
            clearInterval(this.interval);
            this.$router.push({path: '/'});               
          } else {
            this.counter--
          }             
        }, 1000)
    },
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
      },
    formatchargetime(num){
      var hours = Math.floor(num);
      var minutes = Math.floor(((num) - hours) * 60);

      //return (hours + " h " + minutes.toString().padStart(2, '0') + " min");
      return this.$t('setgeneral.hoursminutes',{hours:hours, minutes:minutes.toString().padStart(2, '0')})
    },
    selectchargepower(index){
      this.chargepower=index+this.currentSettings.minCurrent;
    },
    saveGeneral() {
      this.isLoading = true;
      if(this.freecharge)
        this.currentSettings.freeCharging=1;
      else
        this.currentSettings.freeCharging=0;
      if(this.deauth)
        this.currentSettings.stopChargingWithTag=1;
      else
        this.currentSettings.stopChargingWithTag=0;
      if(this.lockcable)
        this.currentSettings.outletConfig='locked';
      else if(!this.lockcable&&this.locktype)
        this.currentSettings.outletConfig='autoA';
      else
        this.currentSettings.outletConfig='auto';

      if(this.ignoreMidError)
        this.currentSettings.ignoreMidError=1;
      else
        this.currentSettings.ignoreMidError=0;

      this.lvdayprice=this.dayprice.replace(',', '.');
      this.lvdayprice=parseInt(this.lvdayprice*1000000);
      let eu_client_name = encodeURIComponent(this.client_info.name);
      let eu_client_info = encodeURIComponent(this.client_info.info);
      let promises = [];
      if(this.$store.state.Role=='operator'){
      promises = ['wallbox/client.php?action=update_client&id='+this.saveto+'&name='+eu_client_name+'&info='+eu_client_info+'&user='+this.$store.state.token,
                  'wallbox/settings.php?action=sync_price&user='+this.$store.state.token+'&client='+this.saveto+'&table=[{%22info%22:%22Tag%22,%22price%22:'+this.lvdayprice+',%20%22start%22:%222022-03-02%2000:00:00%22,%20%22stop%22:%222022-03-02%2024:00:00%22}]',
                  //'wallbox/settings.php?action=sync_max_current&client='+this.saveto+'&freeCharging='+this.currentSettings.freeCharging+'&maxCurrentOperator='+eu_chargepower+'&user='+this.$store.state.token,
                  `wallbox/settings.php?action=sync_max_current&client=${this.saveto}&freeCharging=${this.currentSettings.freeCharging}&maxCurrentOperator=${Number(this.chargeselect) + 6}&user=${this.$store.state.token}`,
                  'wallbox/settings.php?action=sync_deauth&client='+this.saveto+'&stopChargingWithTag='+this.currentSettings.stopChargingWithTag+'&user='+this.$store.state.token,
                  'wallbox/settings.php?action=sync_ignore_mid_error&client='+this.saveto+'&ignoreMidError='+this.currentSettings.ignoreMidError+'&user='+this.$store.state.token,
                ];
      }
      if(this.$store.state.Role=='admin'){
      promises = ['wallbox/client.php?action=update_client&id='+this.saveto+'&name='+eu_client_name+'&info='+eu_client_info+'&user='+this.$store.state.token,
                  //'wallbox/settings.php?action=sync_electrical&client='+this.saveto+'&freeCharging='+this.currentSettings.freeCharging+'&maxCurrentInstall='+eu_chargepower+'&user='+this.$store.state.token,
                  `wallbox/settings.php?action=sync_electrical&client=${this.saveto}&freeCharging=${this.currentSettings.freeCharging}&maxCurrentInstall=${Number(this.chargeselect) + 6}&user=${this.$store.state.token}`,
                  'wallbox/settings.php?action=sync_deauth&client='+this.saveto+'&stopChargingWithTag='+this.currentSettings.stopChargingWithTag+'&user='+this.$store.state.token,
                  'wallbox/settings.php?action=sync_ignore_mid_error&client='+this.saveto+'&ignoreMidError='+this.currentSettings.ignoreMidError+'&user='+this.$store.state.token,
                ];
      }
      if(this.outlet)
        promises.push('wallbox/settings.php?action=sync_outlet&client='+this.saveto+'&mode='+this.currentSettings.outletConfig+'&user='+this.$store.state.token)
      Promise.all(promises.map((promises) => this.axios.get(promises))).then(
      this.axios.spread((...allData) => {
        this.updatePage(allData);
      })
      );
      this.isDirty = false;

    },
    restartBox(){
        this.axios
              .get('wallbox/client.php?action=reboot&user='+this.$store.state.token+'&id='+this.saveto)
              .then((response) => {         
                          if(response.data.status=='ok'){
                            console.log('Restart der Wallbox');
                          }else{
                            console.log('Error send reboot command');                   
                          }
                        })
              .catch((errors) => {
                console.log(errors); // Errors
              });
    },
    resetBox(){
        this.axios
              .get('wallbox/client.php?action=reset_client&id='+this.saveto+'&user='+this.$store.state.token)
              .then((response) => {         
                          if(response.data.status=='ok'){
                            console.log('Reset der Wallbox');
                          }else{
                            console.log('Error send reset command');                   
                          }
                        })
              .catch((errors) => {
                console.log(errors); // Errors
              });
    },
    updatePage(){
      this.isLoading = true;
      let client_infoUrl = 'wallbox/client.php?action=client_info&user='+this.$store.state.token;
      let clients_listUrl = 'wallbox/client.php?action=get_clients&user='+this.$store.state.token;
      let client_priceUrl = 'wallbox/info.php?action=get_price&user='+this.$store.state.token+'&client='+this.$store.state.WbId;
      let client_settingUrl = 'wallbox/info.php?action=get_settings&user='+this.$store.state.token+'&client='+this.$store.state.WbId;
      let client_swversionUrl = 'wallbox/info.php?action=get_version&user='+this.$store.state.token+'&client='+this.$store.state.WbId;  
      const requestclient_info = this.axios.get(client_infoUrl);  
      const requestclients_list = this.axios.get(clients_listUrl);
      const requestclient_price = this.axios.get(client_priceUrl);
      const requestclient_setting = this.axios.get(client_settingUrl);
      const requestclient_swversion = this.axios.get(client_swversionUrl);
      this.axios
          .all([requestclient_info,requestclients_list,requestclient_price,requestclient_setting,requestclient_swversion])
          .then(
              this.axios.spread((...responses) => {
                  const responseclient_info = responses[0];
                  const responseclients_list = responses[1];
                  const responseclient_price = responses[2];
                  const responseclient_setting = responses[3];
                  const responseclient_swversion = responses[4];

                  if(this.$store.state.Mesh){
                    if(responseclients_list.data.status=='token'){
                        this.$router.push({path: '/'});             
                    }else if(responseclients_list.data.status=='ok'){
                      if(responseclients_list.data.tbl_clients!=''){
                        this.clients_list = responseclients_list.data.tbl_clients.sort((a,b) => a.id - b.id);
                        this.clients_list.forEach(item => { 
                            item.name = this.decodeHtml(item.name);
                            item.info = this.decodeHtml(item.info);
                          });
                        this.client_info = this.clients_list[this.clients_list.findIndex(wb => wb.id == this.$store.state.WbId)];  
                      }else{
                        console.log('Clients List Table ist leer');
                      }
                    }else{
                      console.log('Error get Clients List Table');
                    }
                  }else{
                    if(responseclient_info.data.status=='token'){
                        this.$router.push({path: '/'});             
                    }else if(responseclient_info.data.status=='ok'){
                      this.client_info = responseclient_info.data.tbl_clientsettings;  
                      this.client_info.name = this.decodeHtml(this.client_info.name);
                      this.client_info.info = this.decodeHtml(this.client_info.info);                                 
                    }else{
                      console.log('Error get Client Info Table');
                    }
                  }

                  if(responseclient_price.data.status=='token'){
                        this.$router.push({path: '/'});             
                    }else if(responseclient_price.data.status=='ok'){
                    this.currrentPricelist = responseclient_price.data.tbl_price;
                    if(this.currrentPricelist!=''){
                      this.dayprice = (this.currrentPricelist[0].price/1000000).toString();
                      
                      if(this.dayprice!=0)
                        this.dayprice = this.dayprice.replace('.', ',');                
                    }                               
                  }else{
                    console.log('Error get Client Price Table');
                  }

                  if(responseclient_setting.data.status=='token'){
                        this.$router.push({path: '/'});             
                    }else if(responseclient_setting.data.status=='ok'){
                    this.currentSettings = responseclient_setting.data.tbl_settings;
                    if(this.currentSettings.freeCharging==1)
                      this.freecharge=true;
                    else
                      this.freecharge=false;
                    if(this.currentSettings.stopChargingWithTag==1)
                      this.deauth=true;
                    else
                      this.deauth=false;
                    if(this.currentSettings.outlet==1)
                      this.outlet=true;
                    else
                      this.outlet=false;
                    if(this.currentSettings.outletConfig=='locked'){
                      this.lockcable=true;
                      this.locktype=false;
                    } else if (this.currentSettings.outletConfig=='autoA'){
                      this.lockcable=false;
                      this.locktype=true;
                    }else{
                      this.lockcable=false;
                      this.locktype=false;
                    }
                    if(this.currentSettings.midError==1)
                      this.midError=true;
                    else
                      this.midError=false;
                    if(this.currentSettings.ignoreMidError==1)
                      this.ignoreMidError=true;
                    else
                      this.ignoreMidError=false;

                    if(this.currentSettings.noOfPhasesInstall==1)
                      this.chargepowerlist = ['1,38','1,61','1,84','2,07','2,30','2,53','2,76','2,99','3,22','3,45','3,68','3,91','4,14','4,37','4,60','4,83','5,06','5,29','5,52','5,75','5,98','6,21','6,44','6,67','6,90','7,13','7,36'];
                    if(this.currentSettings.noOfPhasesInstall==3)
                      this.chargepowerlist = ['4,14','4,83','5,52','6,21','6,90','7,59','8,28','8,97','9,66','10,35','11,04','11,73','12,42','13,11','13,80','14,49','15,18','15,87','16,56','17,25','17,94','18,63','19,32','20,01','20,70','21,39','22,08'];

                    if(this.$store.state.Role=='operator'){
                      this.chargepowerlist = this.chargepowerlist.slice(0,this.currentSettings.maxCurrentInstall-this.currentSettings.minCurrent+1);
                      this.chargepower = this.currentSettings.maxCurrentOperator;
                      //this.chargeselect = this.chargepower-this.currentSettings.minCurrent;   
                      this.chargeselect = Number(this.currentSettings.maxCurrentOperator-6);                   
                    } else if(this.$store.state.Role=='admin'){
                      this.chargepowerlist = this.chargepowerlist.slice(0,this.currentSettings.maxCurrent-this.currentSettings.minCurrent+1);
                      this.chargepower = this.currentSettings.maxCurrentInstall;
                      this.chargeselect = Number(this.currentSettings.maxCurrentInstall-6);                        
                    }
                  }else{
                    console.log('Error get Client Settings Table');
                  }

                  if(responseclient_swversion.data.status=='token'){
                        this.$router.push({path: '/'});             
                  }else if(responseclient_swversion.data.status=='ok'){
                    if(responseclient_swversion.data.tbl_version!=''){
                      this.swversions = responseclient_swversion.data.tbl_version;
                    }
                  }else{
                    console.log('Error get Client Swversion Table');
                  }

              this.isLoading = false; 
              })
          )
          .catch((errors) => {
              this.isLoading = false;
              console.error(errors);
          });
    },
  },
  created() {
      this.updatePage();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
